export default __webpack_public_path__ + "static/media/peep-3.04441318.svg";